import {Trans} from '@lingui/macro';
import React, {ReactNode, useState} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ResourceDeleteDialog} from './resourceDeleteDialog';

/*
 * Props.
 */

interface ResourceTableActionsProps<T extends {id: unknown}> {
  items: ReadonlyArray<T>;
  selectedIds: ReadonlyArray<T['id']>;
  onDelete?: Handler;

  renderDeleteItemsTitle: (count: number, item: T | undefined) => ReactNode;
  renderDeleteItemsDescription: (count: number) => ReactNode;
}

/*
 * Style.
 */

const StyledResourceTableActionsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const ResourceTableActions = <T extends {id: unknown}>(props: ResourceTableActionsProps<T>) => {
  const {items, selectedIds, onDelete, renderDeleteItemsTitle, renderDeleteItemsDescription} = props;
  const [isShowingConfirmationDialog, setIsShowingConfirmationDialog] = useState(false);

  return (
    <StyledResourceTableActionsContainerDiv>
      {onDelete && (
        <Button
          variant={ButtonVariantsEnum.SECONDARY_DANGER}
          isRounded
          onClick={() => setIsShowingConfirmationDialog(true)}
        >
          <Trans id="table-multi-select-delete">Delete</Trans>
        </Button>
      )}
      {isShowingConfirmationDialog && (
        <ResourceDeleteDialog
          selectedIds={selectedIds}
          items={items}
          onClose={() => setIsShowingConfirmationDialog(false)}
          onDelete={() => {
            setIsShowingConfirmationDialog(false);
            if (onDelete) {
              onDelete();
            }
          }}
          renderDeleteItemsTitle={renderDeleteItemsTitle}
          renderDeleteItemsDescription={renderDeleteItemsDescription}
        />
      )}
    </StyledResourceTableActionsContainerDiv>
  );
};
